export default function TextNavTitle({
  children,
  maxWidth,
  className = '',
  title,
  style
}) {

  return (
    <div className="d-flex align-items-center w-100 gap-2">
      {/* Title */}
      <h5
        className={`text-muted pt-2 fw-bold flex-grow-1 btn-back-text-label text-center text-lg-start ${className}`}
        title={title || children}
        style={{
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          minWidth: 0,
          maxWidth: maxWidth || '100%',
          ...style
        }}
      >
        {children}
      </h5>
    </div>
  )
}